import React, {useState} from "react";
import {useQueryClient} from "react-query";
import {useNavigate} from "react-router-dom";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {tokenSelector} from "../../Recoil/Atom/authState";

import * as departmentApi from "../../api/departmentApi/departmentApi";
import {useRemoveMutation} from "../../hooks/useQueryHooks";
import {ResponseRemove} from "../../models/clientModels/interfaces/Response";
import * as Params from "../../models/clientModels/interfaces/apiParams";
import {initialDepartmentListParams} from "../../models/serverModels/EQDepartment";

import {
  Box,
  Button,
  Pagination,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  styled,
} from "@mui/material";
import {alertStateAtom} from "../../Recoil/Atom/AlertAtom";
import MWSkeleton from "../../components/MWSkeleton";
import SubTitle from "../../components/SubTitle";
import {useDepartmentList} from "../../hooks/useDepartmentList";
import {SubMenuGroup} from "../../styledComponents/StyledListContainer";
import {PaginationContainer} from "../../styledComponents/StyledPagination";
import BusinessIcon from "@mui/icons-material/Business";
import {StyledTableContainer, StyledTableHead} from "../../styledComponents/StyledTable";

const ListContainer = styled(Box)(({theme}) => ({
  minWidth: "1200px",
}));
const DepartmentList = () => {
  const tokenState = useRecoilValue(tokenSelector);

  const [page, setPage] = useState<number>(1);
  const {departmentList, isLoading, isFetching} = useDepartmentList();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const setAlertState = useSetRecoilState(alertStateAtom);

  const {mutate: removeMutate} = useRemoveMutation<ResponseRemove, Params.Remove>({
    api: departmentApi.remove,
    options: {
      onSuccess: () => {
        queryClient.invalidateQueries("departmentList");
      },
    },
  });

  const paginationHandleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  return (
    <ListContainer>
      <SubTitle subTitle="부서목록" />
      <SubMenuGroup>
        <Box></Box>
        <Button
          variant="outlined"
          size="small"
          startIcon={<BusinessIcon />}
          onClick={() => {
            navigate(`/Department/Create`);
          }}
        >
          부서 추가
        </Button>
      </SubMenuGroup>
      <StyledTableContainer

      // sx={{backgroundColor: "#fff", overflow: "auto", height: "60vh"}}
      >
        <Table>
          <StyledTableHead
          // style={{
          //   backgroundColor: "#f0fafa",
          //   position: "sticky",
          //   top: 0,
          //   zIndex: 10,
          // }}
          >
            <TableRow>
              <TableCell align="center">#</TableCell>
              <TableCell align="center">부서명</TableCell>
              <TableCell align="center">인원</TableCell>
              <TableCell align="center" width="15%">
                편집
              </TableCell>
            </TableRow>
          </StyledTableHead>
          <TableBody>
            {isLoading && isFetching ? (
              <MWSkeleton row={12} column={10} />
            ) : (
              departmentList?.items.map((item, index) => (
                <TableRow key={item.uid}>
                  <TableCell align="center">
                    {page === 1
                      ? index + 1
                      : (page - 1) * initialDepartmentListParams.rows! + index + 1}
                  </TableCell>
                  <TableCell align="center">{item.name}</TableCell>
                  <TableCell align="center">{item.usersCount}</TableCell>

                  <TableCell align="center">
                    <Button
                      variant="contained"
                      color="success"
                      size="small"
                      style={{marginRight: "12px"}}
                      onClick={() => {
                        navigate(`/Department/Edit/${item.uid}`);
                      }}
                    >
                      편집
                    </Button>
                    <Button
                      variant="contained"
                      color="secondary"
                      size="small"
                      onClick={() => {
                        setAlertState({
                          toggle: true,
                          message: "등록된 부서를 삭제하시겠습니까?",
                          execution: () => removeMutate({token: tokenState, id: item.uid!}),
                        });
                      }}
                    >
                      삭제
                    </Button>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </StyledTableContainer>
      {/* 페이지네이션 */}
      <PaginationContainer>
        <Pagination
          count={departmentList?.maxPage}
          page={page}
          onChange={paginationHandleChange}
          variant="outlined"
          color="primary"
          shape="rounded"
        />
      </PaginationContainer>
    </ListContainer>
  );
};

export default DepartmentList;
